import Decimal from "decimal.js";
import { DatabaseObject, Metrics } from "./class";
import { DateObject } from "./datetime";

export class Tactic extends DatabaseObject {
  static $route = "tactic";

  functional_location_id: string | null = null;

  tactic_operations: TacticOperation[];

  maintenance_item: string;

  maintenance_plan: string;
  maintenance_plan_description: string;
  strategy: string;
  maintenance_item_description: string;
  functional_location: string;
  functional_location_description: string;
  asset_criticality: string;
  maintenance_item_planning_plant: string;
  maintenance_item_planner_group: string;
  maintenance_item_main_work_center: string;
  maintenance_item_main_work_center_description: string;
  activity_type: string;
  activity_type_description: string;
  task_list: string;
  task_list_header_description: string;

  static async importList(fileId: string) {
    await Tactic.$axios.$post(
      "/tactic/import-list",
      {},
      { params: { fileId } }
    );
  }
}

export class TacticOperation extends DatabaseObject {
  static $route = "tactic-operation";

  tactic_id: string;
  tactic: Tactic;

  cost: Decimal = new Decimal(0);
  operation_number: string;

  maintenance_package: string;
  operation_text: string;
  operation_work_center: string;
  operation_planning_plant: string;
}
